/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-01-16 10:21:20
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-01-31 10:58:49
 * @FilePath: \xm-control-micro-main\src\i18n\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createI18n } from "vue-i18n";

import {
  zhCN,
  en
} from '@/i18n/locales/index'

import {StorageUtils} from 'xmgoing-utils';

const params = new URLSearchParams(location.search)
let locale = params.get('locale') || StorageUtils.getSessionItem("projectI18n")||StorageUtils.getItem("projectI18n") || 'zh-CN';

if(locale==='en'||locale==='en-US'){
  locale='en-US';
}else if(locale==='zh'||locale==='zh_CN'){
  locale='zh-CN';
}
console.log(en,"--------en--------en")
StorageUtils.addSessionItem("projectI18n",locale);
StorageUtils.addItem("projectI18n",locale);

StorageUtils.addSessionItem("projectI18n",locale);
const i18n = createI18n({
  locale,
  fallbackLocale: "zh-CN",
  globalInjection: true,
  messages: {
    "en-US": en,
    "zh-CN": zhCN,
  },
  legacy: false,
});
nextTick(()=>{
  document.querySelector('html')?.setAttribute('lang', locale);
})
export default i18n;
